import { borderRadius, borderColor, borderWidth, paddingSize } from "../../Utilities/utils/Theming";

export const COLOR_OPTIONS = {
	primary: 'var(--epods--color-grey-0)',
	secondary: 'var(--epods--color-grey-700)',
	tertiary: 'var(--epods--color-bluegrey-500)',
	toggle: 'var(--epods--color-bluegrey-500)',
};

export const popoverStyle = () => {
	return {
		paddingTop: 0,
		paddingBottom: 0,
	}
};

export const popoverInnerStyle = () => {
	return {
		paddingTop: 0,
		paddingBottom: 0,
		paddingRight: 0,
		paddingLeft: 0,
		backgroundColor: 'var(--epods--color-bg)',
	};
};

export const popoverArrow = () => {
	return {
		display: 'none',
	};
};



export const popOverBodyStyle = () => {
	return {
		// width: '900px',
		zIndex: 100,
		marginTop: 'var(--epods--space-inset-s)',
		boxShadow: 'var(--epods--box-shadow-third-bottom)',
		...borderRadius('var(--epods--border-radius)'),
		...borderWidth("var(--epods--border-width)"),
		borderStyle: "solid",
		...borderColor("var(--epods--color-border-light)"),
		backgroundColor: 'var(--epods--color-bg-third-elevation)',
		overflow: 'hidden',
		...paddingSize(
			'var(--epods--dropdown-popover-padding-v)',
			'0',
			'calc(var(--epods--dropdown-popover-padding-v) - 5px)',
			'0',
		),
	};
};